import React from 'react';
import Accessory from './Accessory';
import config from '../../../config';
import { Element, scroller } from 'react-scroll';

class Accessories extends React.Component {
	componentDidMount() {
		if (global.location.hash === '#accessories') {
			global.setTimeout(() => {
				scroller.scrollTo('accessories', {
					offset: -45
				});
			}, 50);
		}
	}

	render() {
		const accessoriesList = this.props.accessories.map((accessory, index) => {
			return <Accessory accessory={ accessory } key={ index } />;
		});

		return (
			<section className="product-accessories" id="product-accessories">
				<Element name="accessories">
					<div className="row safes-callout">
						<div className="col sm-3 callout-descr">
							<h2 className="section-title">
								Add Interior Accessories
							</h2>
							<p>Customize your safe to fit your needs.</p>
							<a
								className="btn btn-primary"
								href={`${config.storeUrl}/accessories.html`}
								onClick={ () => {
									global.dataLayer.push({
										event: 'CTA Button',
										eventCategory: 'Button',
										eventAction: 'View All Accessories',
										eventLabel: global.location.pathname
									});
								} }
							>
								View All Accessories
							</a>
						</div>
						<div className="col sm-9 products">
							<ul>
								{ accessoriesList }
							</ul>
						</div>
					</div>
				</Element>
			</section>
		);
	}
}

export default Accessories;


// WEBPACK FOOTER //
// ./src/pages/product/accessories/AccessoriesContainer.js